import InterfaceContactInfo from "../interface/InterfaceContactInfo";

export const EMPTY_CONTACT_INFO: InterfaceContactInfo = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    sendConfirmationSms: true,
    sendReminderEmail: true,
    sendReminderSms: true,
    hasConsented: false
}

export default EMPTY_CONTACT_INFO;